export const HIGH_PERCENTAGE_BREAKPOINT = 15;

export const RADIAN = Math.PI / 180;
